import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import NotFound from '../views/NotFound.vue'
import GStore from '../gstore'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: "Welcome to Head Check"}
  },
  {
    path: '/login',
    name: 'LogIn',
    component: () => import(/* webpackChunkName: "about" */ '../views/LogIn.vue'),
    meta: { title: "Login" }
  },
  {
    path: '/thoughts/',
    component: () => import(/* webpackChunkName: "about" */ '../views/Thoughts.vue'),
    children:[
      {
        path: '/thoughts/',
        name:"Thoughts",
        component: () => import(/* webpackChunkName: "about" */ '../components/ThoughtList.vue'),
        meta: { title: "Thoughts", requireAuth: true },
      },
      {
        path: '/thoughts/add',
        name: 'ThoughtForm',
        component: () => import(/* webpackChunkName: "about" */ '../components/ThoughtForm.vue'),
        meta: { title: "Record a Thought", requireAuth: true }
      },
      {
        path: '/thoughts/:thoughtId',
        name: 'EditThought',
        component: () => import(/* webpackChunkName: "about" */ '../components/ThoughtForm.vue'),
        props:true,
        meta: { title: "Edit a Thought", requireAuth: true }
      },
      {
        path: 'thoughts/charts',
        name: 'Charts',
        component: () => import(/* webpackChunkName: "about" */ '../views/Charts.vue'),
        meta: { title: "Charts", requireAuth: true }
      },
    ]
  },
  
  // { path:"/:catchAll(.*)", component: NotFound }
  { path:"/404", component: NotFound},
  { path:"/:catchAll(.*)", redirect: "/404" }
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// To update the page title:
const DEFAULT_TITLE = 'Some Default Title';
router.afterEach((to, from) => {
    document.title = to.meta.title || DEFAULT_TITLE;
});


router.beforeEach((to, from, next) => {
  if (to.name != "LogIn" && to.meta.requireAuth && GStore.currentUser == null) {
    //console.log("this page requires authentication");
    next({name:"LogIn"});
    
    // // Apparently you can set an access token in local storage
    // // when a user authenticates, and then check it here
    // if (!localStorage.getItem("token")) {
    //   next("/"); // redirects back to the home page
    // } else {
    //   next();
    // }
    
  } else {
    next();
  }
});

export default router
